<button class="btn-action button btn-text" mat-stroked-button color="primary" (click)="onMainClick($event)">{{ value }}</button>
<button class="btn-action button btn-icon" mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="icon" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
</button>
